import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import remarkMath from 'remark-math'
import rehypeKatex from 'rehype-katex'
import 'katex/dist/katex.min.css'
import s from '../../styles/pages/DiscussionDetailPage.module.css'

// Normalize LaTeX delimiters so remark-math can parse them.
// The AI outputs \(...\) for inline and \[...\] for block math.
// [^\S\n]* strips any horizontal whitespace (spaces/tabs) before \[ so the
// replacement $$ always starts at column 0 — remark-math's block fence parser
// requires this; an indented $$ (e.g. inside a list item) is not recognised.
function preprocessMath(content: string): string {
  // Block math first to avoid inline regex consuming \( inside \[...\]
  let result = content.replace(
    /[^\S\n]*\\\[([\s\S]*?)\\\]/g,
    (_, math) => `\n\n$$\n${math.trim()}\n$$\n\n`
  )
  result = result.replace(/\\\(([\s\S]*?)\\\)/g, (_, math) => `$${math}$`)
  return result
}

export function AIMarkdownContent({ content }: { content: string }) {
  return (
    <div className={s.aiMarkdown}>
      <Markdown
        remarkPlugins={[remarkGfm, remarkMath]}
        rehypePlugins={[rehypeKatex]}
        components={{
          a({ href, children }) {
            return (
              <a href={href} target="_blank" rel="noopener noreferrer" className={s.mdLink}>
                {children}
              </a>
            )
          },
        }}
      >
        {preprocessMath(content)}
      </Markdown>
    </div>
  )
}
